<template>
  <div class="card p-3 border-radius-xl" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">Imagens da Obra</h5>
    <p class="mb-0 text-sm mb-4">As imagens da obra são atualizados a cada dois meses</p>
    <p class="mb-0 text-sm mb-4" v-if="props.images['lastUpdate']">Atualizado em: {{ formatDate(props.images['lastUpdate']) }}</p>
    <div class="row text-center">
      <div v-if="images && images.length > 0" class="d-flex justify-content-center flex-wrap">
        <div v-if="props.images[1]" class="col-lg-6 col-md-12 col-sm-12 col-12 mb-2">
          <Image :src="props.images[1]" alt="Image1" width="250" height="200" preview />
        </div>
        <div v-if="props.images[2]" class="col-lg-6 col-md-12 col-sm-12 col-12 mb-2">
          <Image :src="props.images[2]" alt="Image1" width="250" height="200" preview />
        </div>
      </div>

      <div v-else>
        <p class="segment-primary-color font-weight-bolder mt-4 mb-4">Não há imagens disponíveis deste empreendimento
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import Image from 'primevue/image';
import moment from 'moment';

const props = defineProps({
  images: {
    type: Array,
    default: () => [],
  }
});

const formatDate = (dataString) => {
  const data = moment(dataString, 'YYYY-MM-DD HH:mm:ss');
  return data.format('DD/MM/YYYY');
};

console.log(props)
</script>
<style scoped>
.row {
  display: flex;
  justify-content: center;
}
</style>
